const common = {
    retry: 'Erneut versuchen',
    refresh: 'Aktualisieren',
    // Navigation
    dashboard: 'Dashboard',
    products: 'Produkte',
    customers: 'Kunden',
    analytics: 'Analytics',
    settings: 'Einstellungen',
    billing: 'Abrechnung',
    
    // Actions
    saveChanges: 'Änderungen speichern',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    duplicate: 'Duplizieren',
    archive: 'Archivieren',
    save: 'Speichern',
    cancel: 'Abbrechen',
    submit: 'Senden',
    search: 'Suchen',
    filter: 'Filtern',
    export: 'Exportieren',
    import: 'Importieren',
    update: 'Aktualisieren',
    add: 'Hinzufügen',
    manage: 'Verwalten',
    view: 'Ansehen',
    viewAll: 'Alle anzeigen',
    creating: 'Erstelle...',
    saving: 'Speichere...',
    viewDetails: 'Details anzeigen',
    back: 'Zurück',
    configure: 'Konfigurieren',
    noCredits: 'Keine Credits',
    
    // Confirmation Dialogs
    areYouSure: 'Sind Sie sicher?',
    deleteEndpointConfirmation: 'Diese Aktion kann nicht rückgängig gemacht werden. Dies wird den Endpoint dauerhaft löschen und vom Gateway entfernen.',
    deleteNodeConfirmation: 'Dieser Vorgang löscht den Automationsknoten dauerhaft. Dies kann nicht rückgängig gemacht werden.',
    deleteFeatureFlagConfirmation: 'Sind Sie sicher, dass Sie das Feature-Flag "{{displayName}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden. Pläne, die derzeit dieses Feature-Flag verwenden, müssen aktualisiert werden.',
    
    // Status
    active: 'Aktiv',
    inactive: 'Inaktiv',
    online: 'Online',
    offline: 'Offline',
    loading: 'Lädt...',
    error: 'Fehler',
    success: 'Erfolg',
    warning: 'Warnung',
    pending: 'Ausstehend',
    synced: 'Synced',
    healthy: 'healthy',
    warnings: 'Warnungen',
    default: 'Standard',
    
    // Common UI
    home: 'Startseite',
    about: 'Über uns',
    contact: 'Kontakt',
    help: 'Hilfe',
    profile: 'Profil',
    logout: 'Abmelden',
    login: 'Anmelden',
    details: 'Details',
    description: 'Beschreibung',
    name: 'Name',
    email: 'E-Mail',
    version: 'Version',
    status: 'Status',
    actions: 'Aktionen',
    tags: 'Tags',
    type: 'Typ',
    translations: 'Übersetzungen',
    defaultLanguage: 'Standardsprache',
    originalText: 'Originaltext',
    show: 'Anzeigen',
    hide: 'Ausblenden',
    yes: 'Ja',
    no: 'Nein',
    or: 'ODER',
    none: 'Keine',
    defaultValue: 'Standard',
    role: 'Rolle',
    searchPlaceholder: 'Suchen...',
    clearFilters: 'Filter löschen',
    noDescription: 'Keine Beschreibung',
    errorLoadingData: 'Fehler beim Laden der Daten',
    
    // Time
    minAgo: 'vor {{count}} Min.',
    hours24: '24h',
    never: 'Nie',
    lastUsed: 'Zuletzt verwendet',
    
    // Numbers
    operations: 'Operations',
    endpoints: 'Endpoints',
    
    // Buttons
    startFreeTrial: 'Kostenlose Testversion starten',
    privacyPolicy: 'Datenschutzerklärung',
    termsOfService: 'Nutzungsbedingungen',
    helpSupport: 'Hilfe & Support',
    close: 'Schließen',
    comingSoonNotice: 'Diese Funktion befindet sich derzeit in Entwicklung und wird bald verfügbar sein.',
  } as const;

export default common;
